import React, { useState, useEffect } from "react";
import "./typewriter.css";

function Typewriter({ text, speed = 50 }) {
  const [index, setIndex] = useState(0);
  const [displayedText, setDisplayedText] = useState("");
  const [isTypingComplete, setIsTypingComplete] = useState(false);

  useEffect(() => {
    if (!text) {
      setDisplayedText("Something went wrong");
    }
    if (text && index < text.length) {
      setTimeout(() => {
        setDisplayedText((prev) => prev + text.charAt(index));
        setIndex(index + 1);
      }, speed);
    } else {
      setIsTypingComplete(true);
    }
  }, [index, text, speed]);
  return (
    <div
      className="chatbot-answer"
      style={{ color: `${text ? "black" : "red"}` }}
    >
      {displayedText}
      {!isTypingComplete && <span className="cursor"></span>}
    </div>
  );
}

export default Typewriter;
